(function () {
  angular.module("akitabox.building").run(states);

  /* @ngInject */
  function states(Router, models, CacheFactory) {
    Router.configureStates([
      {
        state: "app.building",
        config: {
          abstract: true,
          url: "/buildings/:buildingId",
          templateUrl: "app/mobile/modules/building/building.html",
          controller: "BuildingController",
          controllerAs: "vm",
          resolve: {
            building: getBuilding,
            organization: getOrganization,
            initializeCaches: initializeCaches,
          },
        },
      },
      {
        state: "app.buildings",
        config: {
          url: "/buildings?q",
          templateUrl: "app/mobile/modules/building/list/list.html",
          controller: "BuildingsListController",
          controllerAs: "vm",
          reloadOnSearch: false,
          onEnter: function () {
            CacheFactory.clearAll();
          },
          resolve: {
            query: getQuery,
          },
          data: {
            pageTitle: "Buildings",
          },
        },
      },
    ]);
  }

  // ------------------------
  //   Detail
  // ------------------------

  /* @ngInject */
  function getBuilding(
    $rootScope,
    /* Third-party */
    $state,
    $stateParams,
    /* Resolve */
    account, // wait for account to resolve
    /* Services */
    BuildingService,
    ToastService
  ) {
    return BuildingService.getById($stateParams.buildingId)
      .then(function (building) {
        $rootScope.$broadcast("building:change", building);
        BuildingService.setCurrent(building);
        return building;
      })
      .catch(ToastService.showError);
  }

  /* @ngInject */
  function getOrganization(
    /* Resolve */
    building,
    /* Services */
    OrganizationService
  ) {
    return OrganizationService.getById(building.organization);
  }

  /**
   * Initialize certain caches on page load for a given building. Calling each
   * service's `getAll` will automatically take care of putting the fetched
   * results in each entity's respective cache.
   *
   * @ngInject
   */
  function initializeCaches(
    // Resolves
    account,
    building,
    // Services
    FloorService,
    PinTypeService,
    ToastService
  ) {
    // Initialize certain caches
    FloorService.getAll(building._id).catch(ToastService.showError);
    PinTypeService.getAll(building._id).catch(ToastService.showError);
  }

  // ------------------------
  //   List
  // ------------------------

  /** @ngInject */
  function getQuery(account, $stateParams) {
    return $stateParams.q;
  }
})();
